// extracted by mini-css-extract-plugin
module.exports = {"root":"Matches_root__1Y3Yb","conversationList":"Matches_conversationList__XL921","container":"Matches_container__3mLQj","content":"Matches_content__3a6tn"};